export default theme => ({
  paper: {
    height: theme.spacing.unit * 100,
    width: '100%',
    overflow: 'auto',
  },
});


// WEBPACK FOOTER //
// ./src/modules/universities/cards/UniversityCard/styles.js